import React from "react";
import ReactGA from "react-ga4";

import "../LandingPage/LandingPage.scss";

function LandingPage() {
  ReactGA.initialize("G-Q9G54ZT5FB");
  ReactGA.send("pageview");
  return (
    <div className="landing-page">
      <header>
        <div className="header-left">
          <h1>
            Focus on your thoughts,
            <br /> not how to organize them.
          </h1>
        </div>
        <div className="header-right">
          <svg
            width="84"
            height="84"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M47.871 69.214a13.37 13.37 0 0 1-11.742 0l-12.061-5.886c-3.71-1.811-6.405-5.235-7.321-9.303l-2.979-13.226a13.853 13.853 0 0 1 2.613-11.601l8.346-10.607a13.466 13.466 0 0 1 10.58-5.162h13.387c4.117 0 8.011 1.9 10.579 5.162l8.346 10.607a13.852 13.852 0 0 1 2.613 11.6l-2.979 13.227c-.916 4.068-3.61 7.492-7.32 9.303L47.87 69.214Zm-17.12-18.476c-.734 1.597.914 3.245 2.51 2.511l7.948-3.654c.502-.23 1.08-.23 1.581 0l7.948 3.654c1.596.734 3.244-.914 2.51-2.51l-3.654-7.948a1.893 1.893 0 0 1 0-1.582l3.654-7.947c.734-1.596-.914-3.245-2.51-2.51l-7.948 3.653c-.502.231-1.08.231-1.581 0l-7.948-3.654c-1.596-.734-3.244.915-2.51 2.511l3.654 7.947c.23.502.23 1.08 0 1.582l-3.654 7.947Z"
              fill="#0B062A"
            />
            <path
              d="M2 70.572V78a4 4 0 0 0 4 4h7.429M82 70.572V78a4 4 0 0 1-4 4h-7.429M2 13.429V6a4 4 0 0 1 4-4h7.429M82 13.429V6a4 4 0 0 0-4-4h-7.429"
              stroke="#0B062A"
              strokeOpacity=".16"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </header>
      <div className="footer">
        <p>
          Krnl is a new way to capture what’s on your mind, without getting in
          the way.
        </p>
        <a
          href="https://airtable.com/shrC5eRM3U2GwYHq0"
          target="_blank"
          rel="noreferrer"
        >
          Join the waitlist
        </a>
      </div>
    </div>
  );
}

export default LandingPage;
